import { default as outcomeDiary } from "./outcomeDiary.json";
import { default as outcomeDiaryInsight } from "./outcomeDiaryInsight.json";
import { default as patientReportedOutcome } from "./patientReportedOutcome.json";

const data: { [key: string]: object } = {
  "2": outcomeDiary,
};

const outcomeDiaryInsights: { [key: string]: object } = {
  "304323": outcomeDiaryInsight,
};

const patientReportedOutcomes: { [key: string]: object } = {
  "304323": patientReportedOutcome,
};

const outcomeDiaries = {
  getOutcomeDiary: (diaryIdentifier: string) => data[diaryIdentifier],
  getOutcomeDiaryInsight: (insightIdentifier: string) =>
    outcomeDiaryInsights[insightIdentifier],
  getPatientReportedOutcome: (outcomeID: string) =>
    patientReportedOutcomes[outcomeID],
};

export default outcomeDiaries;
